const ENDPOINT_MY_BANK = '/secure/me/bank'
const ENDPOINT_MY_BANK_ID = '/secure/me/bank/:bankId'

export const state = () => ({})

export const mutations = {}

export const getters = {}

export const actions = {
  async createBankAccount({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.post(ENDPOINT_MY_BANK, payload)
      //      console.log(response)
      return Promise.resolve(response)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async deleteBankAccount({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.delete(
        ENDPOINT_MY_BANK_ID.replace(':bankId', payload)
      )
      //      console.log(response)
      return Promise.resolve(response)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async updateBankAccount({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.put(
        ENDPOINT_MY_BANK_ID.replace(':bankId', payload.bankId),
        payload.model
      )
      //      console.log(response)
      return Promise.resolve(response)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  }
}
